// /Users/pedroara/dev/moblive/t2educacao/app/javascript/frontend/lms/components/questions/interactive/questionInteractiveUtils.js
export const sortPromptsByPosition = (prompts = []) =>
  [...prompts].sort((a, b) => (a?.position || 0) - (b?.position || 0));

export const toPromptMap = (prompts = []) =>
  prompts.reduce((acc, prompt) => {
    if (prompt?.id == null) return acc;
    acc[prompt.id] = prompt;
    return acc;
  }, {});

export const toAlternativeMap = (prompt = {}) =>
  (prompt?.alternatives || []).reduce((acc, alternative) => {
    if (alternative?.id == null) return acc;
    acc[alternative.id] = alternative;
    return acc;
  }, {});

export const getStartPrompt = (prompts = []) =>
  prompts.find((prompt) => prompt?.isStart) || prompts[0] || null;

export const buildAnswersByPrompt = (answers = [], questionId) => {
  const byPrompt = {};

  answers.forEach((answer) => {
    const answerQuestionId = answer?.questionId;
    const promptId = answer?.questionPromptId;
    if (answerQuestionId == null || promptId == null) return;
    if (Number(answerQuestionId) !== Number(questionId)) return;
    if (byPrompt[promptId]) return;
    byPrompt[promptId] = answer;
  });

  return byPrompt;
};

export const buildConversationPath = ({
  startPrompt,
  promptsById,
  answersByPrompt,
}) => {
  if (!startPrompt?.id) return [];

  const entries = [];
  const visited = new Set();
  let currentPrompt = startPrompt;

  while (currentPrompt && currentPrompt.id != null && !visited.has(currentPrompt.id)) {
    visited.add(currentPrompt.id);
    const answer = answersByPrompt[currentPrompt.id] || null;
    entries.push({ prompt: currentPrompt, answer });

    if (!answer) break;

    const alternativesById = toAlternativeMap(currentPrompt);
    const selectedAlternative = alternativesById[answer.questionPromptAlternativeId];
    const nextPromptId = selectedAlternative?.nextPromptId;
    if (nextPromptId == null) break;

    currentPrompt = promptsById[nextPromptId];
  }

  return entries;
};

export const getCurrentConversationEntry = (entries = []) =>
  entries.length > 0 ? entries[entries.length - 1] : null;

function mulberry32(seed) {
  return function () {
    seed |= 0;
    seed = (seed + 0x6d2b79f5) | 0;
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function seededShuffle(array, seed) {
  if (!array || array.length <= 1) return array;
  const shuffled = [...array];
  const rng = mulberry32(seed);
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

